var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0H15V1.66667H6.66667V0ZM6.66667 3.33333H11.6667V5H6.66667V3.33333ZM6.66667 8.33333H15V10H6.66667V8.33333ZM6.66667 11.6667H11.6667V13.3333H6.66667V11.6667ZM0 0H5V5H0V0ZM1.66667 1.66667V3.33333H3.33333V1.66667H1.66667ZM0 8.33333H5V13.3333H0V8.33333ZM1.66667 10V11.6667H3.33333V10H1.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListItems);
export default __webpack_public_path__ + "static/media/listItems.0388745693afa3370e379d798267ba20.svg";
export { ForwardRef as ReactComponent };